export const tool = {
  name: 'start-scene',
  description: 'Begin real-time interaction with the character in the scene.',
  type: 'function',
  parameters: {
    type: 'object',
    properties: {
      message: {
        type: 'string',
        description: 'Confirmation or status message when starting the scene.',
        default: 'Starting live scene',
      },
    },
    required: ['message'],
  },
};
